
import {
    defineComponent
} from 'vue';

export default defineComponent({
    props: {
        technology: {
            type: String,
            required: true
        },
    }

});
